
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./health.cjs.production.min.js')
} else {
  module.exports = require('./health.cjs.development.js')
}
